import '@/plugins/currencyCodes';

import Vue from 'vue';
import { mapActions, mapState } from 'vuex';

import CalculatorPage from '@/components/Calculator/CalculatorPage';
import { i18n } from '@/i18n';
import router from '@/route/calculator';
import store from '@/store/calculator/index';

// eslint-disable-next-line no-unused-vars
/* global context, dispatch */

export function createApp () {
  const app = new Vue({ // eslint-disable-line no-new
    render(h) {
      return h(CalculatorPage, {
        props: {
          promoInfo: this.promoInfo,
        }
      });
    },
    data: () => ({
      promoInfo: null,
    }),
    i18n,
    store,
    router,
    computed: {
      ...mapState('calculator', ['price', 'selectedAmount']),
    },
    serverPrefetch () {
      return this.initiateState(context);
    },
    beforeMount () {
      if (this.$store.state.calculator.heading) {
        this.reInitiateBigNumber();

        return;
      }

      const context = JSON.parse(JSON.stringify(this.$el.dataset));
      context.cryptoCurrency = JSON.parse(context.cryptoCurrency);
      context.fiatCurrency = JSON.parse(context.fiatCurrency);
      context.market = JSON.parse(context.market);
      context.breadcrumbs = JSON.parse(context.breadcrumbs);

      this.promoInfo = JSON.parse(context.promoInfo ?? 'null');

      if (context.isMemberPage) {
        this.$store.commit('calculator/setAsMemberPage');
      }

      this.initiateState(context);

      const placeholderLoader = document.getElementById('placeholder-loader');
      if (placeholderLoader !== null) {
        placeholderLoader.style.display = 'none';
      }
    },
    methods: {
      ...mapActions({
        requestPrice: 'calculator/requestPrice',
        requestUsdAggregatePrice: 'calculator/requestUsdAggregatePrice',
        requestRecentConversions: 'calculator/requestRecentConversions',
      }),
      initiateState ({
        language,
        cryptoCurrency,
        fiatCurrency,
        market,
        amount,
        isCryptoAmount,
        isGuest,
        breadcrumbs,
        heading,
        isCorporateAccount,
        defaultBuyLink,
      }) {
        this.$store.commit('calculator/setCryptoCurrency', cryptoCurrency);
        this.$store.commit('calculator/setFiatCurrency', fiatCurrency);
        this.$store.commit('calculator/setMarket', market);
        this.$store.commit('calculator/setAmount', amount);
        this.$store.commit('calculator/setIsGuest', Boolean(isGuest));
        this.$store.commit('calculator/setHeading', heading);
        this.$store.commit('calculator/setBreadcrumbs', breadcrumbs);
        this.$store.commit('language', language);
        this.$store.commit('calculator/setIsCorporateAccount', Boolean(isCorporateAccount));
        this.$store.commit('calculator/setDefaultBuyLink', defaultBuyLink);
  
        if (!isCryptoAmount) {
          this.$store.commit('calculator/setSelectedAmountFiat', amount);
        }

        return Promise.all([
          this.requestRecentConversions(),
          this.requestUsdAggregatePrice(cryptoCurrency),
          this.requestPrice({
            market,
            cryptoCurrency,
            fiatCurrency,
          }),
        ]);
      },
      reInitiateBigNumber () {
        // XXX: After SSR these values are converted to strings inside store, so we need to re-set them to BigNumber objects
        this.$store.commit('calculator/setAmount', this.selectedAmount);
      },
    },
  });

  return { app, store, router };
}
